import { navTypes } from '../Types/Nav.types';

const INITIAL_STATE = {
  menuSlide: false,
};

export const navReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case navTypes.MENU_SLIDE:
      return {
        ...state,
        menuSlide: !state.menuSlide,
      };
    default:
      return state;
  }
};
